var map = {
	"./ic_about.svg": 1556,
	"./ic_apps.svg": 1793,
	"./ic_arrow-up.svg": 7624,
	"./ic_back.svg": 2858,
	"./ic_clear.svg": 5922,
	"./ic_close.svg": 982,
	"./ic_dark.svg": 2236,
	"./ic_dots.svg": 3288,
	"./ic_dropdown.svg": 7327,
	"./ic_email.svg": 34,
	"./ic_expand.svg": 5759,
	"./ic_figure.svg": 1859,
	"./ic_gear.svg": 2497,
	"./ic_home.svg": 1350,
	"./ic_in-browser.svg": 7299,
	"./ic_in-new.svg": 3508,
	"./ic_list.svg": 6584,
	"./ic_logout.svg": 6696,
	"./ic_menu-close.svg": 7519,
	"./ic_menu.svg": 8060,
	"./ic_minus.svg": 9650,
	"./ic_msg.svg": 2018,
	"./ic_person.svg": 7028,
	"./ic_play.svg": 2876,
	"./ic_plus.svg": 6313,
	"./ic_projects.svg": 9131,
	"./ic_search.svg": 181,
	"./ic_sort.svg": 9810,
	"./ic_telegram.svg": 8350,
	"./ic_upload.svg": 6224,
	"./logo.svg": 4386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;